/* eslint-disable @next/next/no-img-element */
import React from "react";
import styles from "./styles.module.scss";
import TextLoopAnimation from "../LoopTextHelper/TextLoopAnimation";

export default function TeamHeroSection({ windowSize }) {
  const texts = [
    {
      title: "Professionals",
    },
    {
      title: "Business Owners",
    },
    {
      title: "Everyone",
    },
  ];

  return (
    <div className={styles.teams_introduction}>
      <div className={styles.teams_hero_section_animation}>
        <div className={styles.teams_hero_text_section}>
          <div className={styles.teams_hero_text}>
            <h1 className={styles.teams_hero_text_h1_title}>
              Let's make Learning easy for
            </h1>
            <TextLoopAnimation
              type="team"
              windowSize={windowSize}
              texts={texts}
              loopInterval={2000}
            />
          </div>
          <div className={styles.teams_start_learning_button}>
            <a
              className={styles.teams_start_learning}
              href="https://apply.workable.com/seekho/"
              target="_blank"
            >
              Join us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
